import baseApi from './base';

// 获取验证码
const getCode = data =>
  baseApi.request({
    method: 'PUT',
    url: '/user/code',
    data
  });

// 登录
const login = params =>
baseApi.request({
  method: 'post',
  url: '/login',
  params
});

// 登出
const logout = () =>
  baseApi.request({
    method: 'get',
    url: '/logout'
  });

// 获取用户信息
const validate = () =>
  baseApi.request({
    method: 'get',
    url: '/user/home/validate'
  });

// 账号管理-找回密码
const retrievePassword = data =>
  baseApi.request({
    method: 'post',
    url: '/user/retrieve-password',
    data
  });

// 账号管理-获取找回密码验证码
const getPhoneCaptcha = data =>
  baseApi.request({
    method: 'PUT',
    url: '/user/retrieve-password/code',
    data
  });

export {
  getCode,
  login,
  logout,
  validate,
  retrievePassword,
  getPhoneCaptcha
};



// WEBPACK FOOTER //
// ./src/api/Login.js